import type { ReactNode } from 'react';

/**
 * AdminPageHeader — the single page-title treatment shared by every admin tab,
 * so the console headers stay uniform: a left-aligned serif h1 + optional muted
 * subtitle, with an optional right-aligned `aside` slot for badges/actions.
 * Sits on the page background, above the content card(s).
 */
export function AdminPageHeader({
  title,
  subtitle,
  aside,
}: {
  title: string;
  subtitle?: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <div className="mb-5 flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h1
          className="text-navy text-[22px] font-bold leading-tight m-0"
          style={{ fontFamily: 'Georgia, "Times New Roman", serif' }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-muted text-[13.5px] m-0 mt-1 max-w-[680px]">{subtitle}</p>
        )}
      </div>
      {aside && <div className="flex items-center gap-2 shrink-0">{aside}</div>}
    </div>
  );
}
